var __webpack_exports__ = {};
/*!************************************************!*\
  !*** ./src/scripts/product-recommendations.js ***!
  \************************************************/
class ProductRecommendations extends HTMLElement {
  atcEventTracking;
  constructor() {
    super();

    this.atcEventTracking = () => {
      var selectors = "product-recommendations button[name='add']";

      if (jQuery351(selectors).length) {
        jQuery351(selectors).each(function (index) {
          var selector = jQuery351(this).data('index');
          jQuery351("product-recommendations button[data-index='" + selector + "']").on("click",function(event) {
            var elem = jQuery351(this).closest(".grid__item.slider__slide");
            var productName = elem.data("productname");
            var productId =  elem.data("productid");
            var productPrice = elem.data("productprice");
            var productBrand = elem.data("productbrand");
            var productType = elem.data("producttype");
            var productCollection = elem.data("productcollection");
            var variantInput = elem.data("variantinput");
            var shopCurrency =  elem.data("shopcurrency");

            window.dataLayer.push({
              event: 'ee_addToCart',
              name: productName,
              id: productId,
              price: productPrice,
              currency: shopCurrency,
              brand: productBrand,
              product_type: productType,
              category: productCollection,
              quantity: 1,
              variant: variantInput,
              g_product_id: "shopify_GB_"+productId+"_"+variantInput
            });
          });
        });
      }
    };

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.atcEventTracking();
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

